export const createPNodeAfterBlockQuote = (
  rootElement,
  e,
) => {
  if (!e.key || e.key !== 'Enter') return
  const selection = window.getSelection();

  if (!selection || !selection.anchorNode) {
    return;
  }

  // Tìm parent node trực tiếp của editor root
  let currentNode = selection.anchorNode;

  // Nếu là text node, lấy parent element
  if (currentNode.nodeType === Node.TEXT_NODE) {
    currentNode = currentNode.parentElement;
  }

  if (currentNode && currentNode instanceof HTMLElement) {
    // Tìm blockquote parent (không chỉ direct child của root)
    let blockquoteParent = currentNode;

    while (blockquoteParent && blockquoteParent !== rootElement) {
      if (blockquoteParent.tagName.toLowerCase() === "blockquote") {
        break;
      }
      blockquoteParent = blockquoteParent.parentElement;
    }

    // Nếu tìm thấy blockquote và nó không phải là root
    if (
      blockquoteParent &&
      blockquoteParent !== rootElement &&
      blockquoteParent.tagName.toLowerCase() === "blockquote"
    ) {
      // Tìm block element chứa cursor (p, h1, h2, etc.)
      let blockElement = currentNode;
      while (blockElement && blockElement !== blockquoteParent) {
        const tagName = blockElement.tagName?.toLowerCase();
        if (tagName === 'p' || tagName?.startsWith('h')) {
          break;
        }
        blockElement = blockElement.parentElement;
      }

      // Chỉ exit blockquote nếu:
      // 1. Block element rỗng (chỉ có <br> hoặc không có nội dung)
      // 2. Hoặc cursor ở cuối block rỗng
      if (blockElement && blockElement !== blockquoteParent) {
        const textContent = blockElement.textContent?.trim() || '';
        const hasOnlyBr = blockElement.innerHTML === '<br>' || blockElement.innerHTML === '<br/>';

        // Chỉ exit nếu block rỗng
        if (textContent === '' || hasOnlyBr) {
          e.preventDefault();

          // Xóa block rỗng trong blockquote
          if (blockElement.parentNode) {
            blockElement.parentNode.removeChild(blockElement);
          }

          // Tạo thẻ p mới
          const newP = document.createElement("p");
          newP.innerHTML = "<br>";

          // Insert p SAU blockquote (không phải bên trong)
          if (blockquoteParent.nextSibling) {
            rootElement.insertBefore(newP, blockquoteParent.nextSibling);
          } else {
            rootElement.appendChild(newP);
          }

          // Set focus vào p mới
          const range = document.createRange();
          range.setStart(newP, 0);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }
  }
};
